import * as React from "react";
const SvgFly = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 15, r: 7, stroke: "currentColor", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 15, r: 3, fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M12 0L17 4.99996H7.00004L12 0Z", fill: "currentColor" }));
export default SvgFly;
